<div #parentPanel class="parent-panel" [class.expanded]="dashboardHelper.isRightPanelExpanded | async"
  [class.resizing]="isPanelResizing" [style.width.%]="100">
  <app-image-lightbox></app-image-lightbox>
  @if (selectedWorkspaceInstanceNode) {
  <div class="form-container">
    <form #myForm="ngForm">
      <div class="sticky-header">
        <app-edit-panel-header
          [itemType]="nodeHelper.getSelectedNodeTypeNameForHeader(selectedWorkspaceInstanceNode) || ''"
          [itemLabel]="nodeHelper.getSelectedNodeTypeLabelByNodeTypeId(selectedWorkspaceInstanceNode?.nodeTypeId) || ''"
          [itemColor]="nodeHelper.getSelectedNodeTypeColorForHeader(selectedWorkspaceInstanceNode) || ''"
          [itemBackgroundColor]="nodeHelper.getSelectedNodeTypeBackgroundColorForHeader(selectedWorkspaceInstanceNode) || ''"
          [itemBorderStyle]="nodeHelper.getNodeTypeBorderStyle(selectedWorkspaceInstanceNode?.nodeTypeId)"
          [itemTooltip]="nodeHelper.getSelectedNodeTypeTooltipByNodeTypeId(selectedWorkspaceInstanceNode?.nodeTypeId) || ''"
          [nodeKey]="isTestStepSelected && isDoView ? selectedWorkspaceInstanceNode?.key + ' ( Step ' + selectedTestStep?.id + ' )' : selectedWorkspaceInstanceNode?.key"
          [isTestStepSelected]="isTestStepSelected" [isDoView]="isDoView" [childNodeNameList]="childNodeNameList"
          [nodeStatusIcons]="nodeStatusIcons" [nodeStatusValue]="nodeStatusLabel" [nodeStatusLabel]="nodeStatusLabel"
          [nodeStatusTooltip]="nodeStatusTooltip" [nodeStatusChipStyle]="nodeStatusChipStyle"
          [showNodeStatus]="(!isDoView || !isTestStepSelected) && isShowNodeStatus" [nodeStatusReadOnly]="isBacklogStatusReadOnly" [stepStatusReadOnly]="isBacklogRollupReadOnly" [stepStatusIcons]="stepStatusIcons"
          [stepStatusValue]="selectedTestStep?.teststatus || ''" [stepStatusLabel]="stepStatusLabel"
          [stepStatusChipStyle]="stepStatusChipStyle" [showStepStatus]="isTestStepSelected && isDoView"
          [summary]="selectedWorkspaceInstanceNode?.name || ''" (summaryChange)="onSummaryChange($event)"
          (summaryBlur)="onSummaryBlur($event)"
          (navigatePrevious)="onNavigationClicked('previous')"
          (navigateNext)="onNavigationClicked('next')" (addTestStep)="onAddTestStep()"
          (addChildNode)="onAddChildNode($event)" (closePanel)="onClickCloseRightPanel()"
          (changeNodeStatus)="onChangeNodeStatus($event)" (changeStepStatus)="onChangeStepStatus($event)"
          [selectedNode]="selectedWorkspaceInstanceNode" [generateTestsState]="generateTestsState"
          [generateTestsBlockedReason]="generateTestsBlockedReason"
          [hideNavigation]="hideNavigation"></app-edit-panel-header>
        <div class="tabs-container">
          <p-tabs class="panel-tabs" [value]="activeTab" (valueChange)="onTabsValueChange($event)"
            attr.aria-label="Edit panel tabs">
            <p-tablist>
              <p-tab value="overview" attr.aria-label="Overview">
                <div class="panel-tab" [class.panel-tab--icon-only]="activeTab !== 'overview'" pTooltip="Overview"
                  tooltipPosition="bottom">
                  <i class="pi pi-file"></i>
                  @if (activeTab === 'overview') {
                  <span>Overview</span>
                  }
                </div>
              </p-tab>
              <p-tab value="attachments"
                attr.aria-label="Attachments">
                <div class="panel-tab" [class.panel-tab--icon-only]="activeTab !== 'attachments'"
                  [pTooltip]="'Attachments' + (attachmentsCount ? ' (' + attachmentsCount + ')' : '')" tooltipPosition="bottom">
                  <span class="panel-tab__icon">
                    <mat-icon class="panel-tab__mat-icon">attach_file</mat-icon>
                  </span>
                  @if (activeTab === 'attachments') {
                  <span>Attachments</span>
                  }
                </div>
              </p-tab>
              @if (!isTestStepSelected || !isDoView) {
              <p-tab value="comments"
                attr.aria-label="Comments">
                <div class="panel-tab" [class.panel-tab--icon-only]="activeTab !== 'comments'" [pTooltip]="'Comments' + (commentsCount ? ' (' + commentsCount + ')' : '')"
                  tooltipPosition="bottom">
                  <span class="panel-tab__icon">
                    <i class="pi pi-comment"></i>
                  </span>
                  @if (activeTab === 'comments') {
                  <span>Comments</span>
                  }
                </div>
              </p-tab>
              }
              @if (canShowStepsTab) {
              <p-tab value="steps"
                attr.aria-label="Steps">
                <div class="panel-tab" [class.panel-tab--icon-only]="activeTab !== 'steps'" [pTooltip]="'Steps' + (numberOfTestSteps ? ' (' + numberOfTestSteps + ')' : '')"
                  tooltipPosition="bottom">
                  <span class="panel-tab__icon">
                    <svg class="panel-tab__svg" viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path fill="none" stroke="currentColor" stroke-width="2.4" stroke-linejoin="miter" d="M3 19h5v-5h5V9h5V5h3"/></svg>
                  </span>
                  @if (activeTab === 'steps') {
                  <span>Steps</span>
                  }
                </div>
              </p-tab>
              }
              @if (canShowRunsTab) {
              <p-tab value="runs"
                attr.aria-label="Runs">
                <div class="panel-tab" [class.panel-tab--icon-only]="activeTab !== 'runs'" [pTooltip]="'Runs' + (runsCount ? ' (' + runsCount + ')' : '')"
                  tooltipPosition="bottom">
                  <span class="panel-tab__icon">
                    <i class="pi pi-play"></i>
                  </span>
                  @if (activeTab === 'runs') {
                  <span>Runs</span>
                  }
                </div>
              </p-tab>
              }
              <!-- No tab shows a count badge. History in particular must not: a count would need a query
                   on every node selection - see EditPanelHistoryPaneComponent. -->
              <p-tab value="history" attr.aria-label="History">
                <div class="panel-tab" [class.panel-tab--icon-only]="activeTab !== 'history'" pTooltip="History"
                  tooltipPosition="bottom">
                  <i class="pi pi-history"></i>
                  @if (activeTab === 'history') {
                  <span>History</span>
                  }
                </div>
              </p-tab>
            </p-tablist>
            <p-tabpanels>
              <p-tabpanel value="overview">
                <div class="tab-panel tab-panel--overview">
                  <div class="overview-sections">
                    @if (!isTestStepSelected || !isDoView) {
                    <app-edit-panel-description [description]="selectedWorkspaceInstanceNode?.description || ''"
                      [descriptionDraft]="descriptionDraft" (descriptionDraftChange)="descriptionDraft = $event"
                      [isEditing]="isEditingDescription" [formData]="formData"
                      [projectId]="selectedProjectId" [workspaceId]="selectedWorkspace?.id || ''"
                      [nodeInstanceId]="selectedWorkspaceInstanceNode?.id || ''"
                      [nodeKey]="selectedWorkspaceInstanceNode?.key || ''"
                      (startEdit)="startDescriptionEdit()"
                      (saveEdit)="saveDescriptionEdit()"></app-edit-panel-description>
                    }
                    <app-edit-panel-details-pane [detailFieldList]="detailFieldList" [bugFieldList]="bugFieldList"
                      [testInputFieldList]="testInputFieldList" [selectedTestStep]="selectedTestStep" [formData]="formData" [isTestNode]="isTestNode"
                      [projectId]="selectedProjectId" [workspaceId]="selectedWorkspace?.id || ''"
                      [nodeInstanceId]="selectedWorkspaceInstanceNode?.id || ''"
                      [nodeKey]="selectedWorkspaceInstanceNode?.key || ''"
                      [isTestStepSelected]="isTestStepSelected" [isDoView]="isDoView" [localNodeField]="localNodeField"
                      [univeralNodeField]="univeralNodeField" [targetMapsLocalSelected]="targetMapsLocalSelected"
                      [targetMapsUnivlSelected]="targetMapsUnivlSelected"
                      [filteredTargetMapsLocal]="filteredTargetMapsLocal"
                      [filteredTargetMapsUnivl]="filteredTargetMapsUnivl"
                      [targetMapsMergedSelected]="targetMapsMergedSelected"
                      [filteredTargetMapsMerged]="filteredTargetMapsMerged" [epicNameFieldName]="EPIC_NAME_FIELD_NAME"
                      [startDateFieldName]="START_DATE_FIELD_NAME" [dueDateFieldName]="DUE_DATE_FIELD_NAME"
                      [extAppReferenceFieldName]="EXT_APP_REFERENCE_ID_FIELD_NAME"
                      [showEpicNameField]="canShowEpicNameField" [buildDropdownOptions]="buildDropdownOptions"
                      [buildUserDropdownOptions]="buildUserDropdownOptions"
                      (assigneeChange)="checkAndSaveAssigneeValid($event)"
                      (calendarDateChange)="onCalendarDateChange($event.index, $event.value, $event.fieldId)"
                      (calendarDateClear)="onClearDate($event.index, $event.fieldId)" (calendarDateSet)="onSetDate()"
                      (dropdownChange)="onDropDownChange($event.value, $event.fieldName)"
                      (filterTargetMapsLocal)="filterTargetMapsLocal($event)"
                      (filterTargetMapsUnivl)="filterTargetMapsUnivl($event)"
                      (targetMapLocalSelect)="onTargetMapLocalSelect($event)"
                      (targetMapLocalUnselect)="onTargetMapLocalUnselect($event)"
                      (targetMapsLocalClear)="onTargetMapsLocalClear()"
                      (targetMapUnivlSelect)="onTargetMapUnivlSelect($event)"
                      (targetMapUnivlUnselect)="onTargetMapUnivlUnselect($event)"
                      (targetMapsUnivlClear)="onTargetMapsUnivlClear()"
                      (filterTargetMapsMerged)="filterTargetMapsMerged($event)"
                      (targetMapMergedSelect)="onTargetMapMergedSelect($event)"
                      (targetMapMergedUnselect)="onTargetMapMergedUnselect($event)"
                      (targetMapsMergedClear)="onTargetMapsMergedClear()"
                      (stepFieldInputChange)="onStepFieldInputChange($event.value, $event.fieldName)"
                      (inputBlur)="onInputBlur($event.value, $event.fieldName)"
                      (stepFieldImageAttached)="onStepFieldImageAttached($event)"></app-edit-panel-details-pane>
                  </div>
                </div>
              </p-tabpanel>

              <p-tabpanel value="attachments">
                <app-edit-panel-attachments-pane [attachmentsCount]="attachmentsCount" [isDoView]="isDoView"
                  [isTestStepSelected]="isTestStepSelected" [stepFieldsReadOnly]="isBacklogRollupReadOnly"
                  [isPanelExpanded]="dashboardHelper.isRightPanelExpanded | async"
                  [selectedNode]="selectedWorkspaceInstanceNode" [selectedTestStep]="selectedTestStep"
                  [selectedProject]="selectedProject" [selectedWorkspace]="selectedWorkspace"
                  (stepAttachmentSaved)="onStepAttahcmentAdded($event)"></app-edit-panel-attachments-pane>
              </p-tabpanel>

              @if (!isTestStepSelected || !isDoView) {
              <p-tabpanel value="comments">
                <app-edit-panel-comments-pane [commentsCount]="commentsCount" [selectedWorkspace]="selectedWorkspace"
                  [selectedWorkspaceInstanceNode]="selectedWorkspaceInstanceNode"></app-edit-panel-comments-pane>
              </p-tabpanel>
              }

              @if (canShowStepsTab) {
              <p-tabpanel value="steps">
                @if (tableField && testTableFieldIndex !== null) {
                <app-edit-panel-steps-pane [numberOfTestSteps]="numberOfTestSteps" [expanded]="testStepDataTableActive"
                  [tableName]="tableField?.name || ''" [tableData]="getTableData(fieldDataArray)"
                  [tableConfig]="tableConfigurationArray[testTableFieldIndex]" [tableIndex]="testTableFieldIndex"
                  [selectedNode]="selectedNodeViewIntance" [selectedProject]="selectedProject"
                  [selectedWorkspace]="selectedWorkspace" [attachmentsOrg]="attachmentsOrg"
                  [isAutoNumberColumn]="tableField?.value?.isAutoNumberColumn || false" [readOnly]="isBacklogRollupReadOnly"
                  (expandedChange)="onExpandTestTable($event)" (tableDataOutput)="onGetTableDataOutput($event)"
                  (tableEdit)="OnTableEditActivate()"></app-edit-panel-steps-pane>
                }
              </p-tabpanel>
              }

              @if (canShowRunsTab) {
              <p-tabpanel value="runs">
                <app-edit-panel-runs-pane
                  [selectedNode]="selectedNodeViewIntance"
                  [selectedProject]="selectedProject"
                  [selectedWorkspace]="selectedWorkspace"
                  [isExpanded]="!!(dashboardHelper.isRightPanelExpanded | async)"
                  (expandedChange)="dashboardHelper.setExpandRightPanel($event)"
                  (runsCountChange)="onRunsCountChange($event)"></app-edit-panel-runs-pane>
              </p-tabpanel>
              }

              <p-tabpanel value="history">
                <app-edit-panel-history-pane
                  [selectedNode]="selectedNodeViewIntance"
                  [selectedProject]="selectedProject"
                  [selectedWorkspace]="selectedWorkspace"
                  [isActive]="activeTab === 'history'"
                  [isTestNode]="isTestNode"></app-edit-panel-history-pane>
              </p-tabpanel>
            </p-tabpanels>
          </p-tabs>
        </div>
      </div>
    </form>
  </div>
  }
</div>